import React, { useEffect, useState } from "react";
import { useInterval } from "../../../../utils";
import "./styles.scss";

interface CountdownProps {
  onFinish: () => void;
}

type Props = CountdownProps;

const CountdownTimer: React.FC<Props> = React.memo(({ onFinish }) => {
  const [counter, setCounter] = useState(3);

  useInterval(() => {
    setCounter(c => c - 1);
  }, 1000);

  useEffect(() => {
    if (counter === 0) {
      onFinish();
    }
  }, [counter]);

  return (
    <div className={"countdownTimer"}>
      <span className={"countdownText"}>{counter}</span>
    </div>
  );
});

export default CountdownTimer;
